const PION_COMPANY_INFO = {
    logoImageUrl: "/assets/img/pion_logo.png",
    subLogoImageUrl: "/assets/img/pion_logo.png",
    navLogoImageUrl: "/assets/img/pion_logo_white.png",
    stampImageUrl: "/assets/img/pion_stamp.png",
    companyRegistrationNumber: "851 - 86 - 00038",
    companyName: "파이온일렉트릭(주)",
    representative: "윤광희",
    address: "경기도 광명시 일직로 72, 에이동 1801호(일직동)",
    businessType: "제조업",
    businessItem: "전력전자기기",
    representativePhone: "070-5096-4179",
    fax: "0505-300-4179",
};
const PION_CODE_INFO = {
    commercialPrefix: "PE-",
    researchPrefix: "PE(R)-",
    inhouseBidNumberPrefix: "PEPQ_",
    projectPrefix: "PE_",
    commercialPurchasePrefix: "AP-",
    researchPurchasePrefix: "AP(R)-",
};
/**
 * @description 제품 분류 정의를 위한 배열
 * - 시트 헤더 생성 및 요약 시트 데이터 생성에 사용
 *
 * @Error 이름 사용 불가 문자 - * ? : \\ / [ ]
 */
const PRODUCT_CLASSIFICATION_DEFINITIONS = [
    {
        name: "전력변환기",
        simpleCode: "(PE-A)",
        filterKey: "전력변환기-A",
    },
    {
        name: "전력기기",
        simpleCode: "(PE-B)",
        filterKey: "전력기기-B",
    },
    {
        name: "제어기기",
        simpleCode: "(PE-C)",
        filterKey: "제어기기-C",
    },
    {
        name: "통신기기",
        simpleCode: "(PE-D)",
        filterKey: "통신기기-D",
    },
    {
        name: "전원기기",
        simpleCode: "(PE-E)",
        filterKey: "전원기기-E",
    },
    {
        name: "전력전자부품",
        simpleCode: "(PE-F)",
        filterKey: "전력전자부품-F",
    },
    {
        name: "기타자재",
        simpleCode: "(PE-G)",
        filterKey: "기타자재-G",
    },
    {
        name: "잡자재",
        simpleCode: "(PE-H)",
        filterKey: "잡자재-H",
    },
];
const PION_EXCEL_EXPORT_OPTIONS = {
    productClassificationInfo: PRODUCT_CLASSIFICATION_DEFINITIONS.map((option) => ({
        name: `${option.name} ${option.simpleCode}`,
        filterKey: option.filterKey,
    })),
    summaryTitleOptions: {
        columnWidths: [6, 18, 12, 12, 18, 15],
        title: "파이온일렉트릭(주) 자재(재고 자산) 현황",
    },
    summaryRowsOptions: PRODUCT_CLASSIFICATION_DEFINITIONS.map((info, idx) => {
        return {
            no: idx + 1,
            classification: info.filterKey,
            division: info.name,
            code: info.simpleCode || "",
        };
    }),
};
export const PION_ERP_INFO = {
    companyInfo: PION_COMPANY_INFO,
    codeInfo: PION_CODE_INFO,
    excelExportOptions: PION_EXCEL_EXPORT_OPTIONS,
};
